import React from 'react';
import { Grid, Typography } from '@material-ui/core/';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles({
  main: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  labelStyle: {
    flexGrow: 1,
    maxWidth: '100%'
  }
});

const getIsChecked = input => {
  return input.checked;
};

const CheckBoxField = ({
  input,
  label,
  basePath,
  isChecked = getIsChecked,
  classesOverride,
  ...custom
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={0}
      className={clsx(classesOverride && classesOverride.main, classes.main)}
    >
      <Grid item>
        <Checkbox
          {...input}
          {...custom}
          checked={isChecked(input)}
          value={`${input.value}`} //material ui checkbox expects value prop as a string
          id={`checkbox-${label}`}
        />
      </Grid>
      <Grid
        item
        xs={6}
        sm={6}
        md={6}
        lg={6}
        xl={true}
        className={classes.labelStyle}
      >
        <Typography variant="caption">{label}</Typography>
      </Grid>
    </Grid>
  );
};

export default CheckBoxField;
